<template>
  <div>
    <b-modal
      ref="modalCriarRegra"
      size="lg"
      no-close-on-esc
      no-close-on-backdrop
      scrollable
      id="modal-regra-usuario"
      :title="id ? 'Editar regra de Usuário' : 'Criar uma nova regra de usuário'"
      @shown="openModal"
      @hide="fecharModal"
    > 
       <el-form ref="formRegra" v-loading="loadingForm" :model="model" :rules="rules" size="small" label-position="top" class="geral-form">
        <el-form-item label="Nome" prop="nome" required>
          <el-input v-model="model.nome"></el-input>
        </el-form-item>
        <SelectMarcas v-model="model.marcas" :notStorage="true" /> 
        <el-form-item v-loading="loadingListas" label="Grupos" prop="gruposIds">
          <select2-multiple v-if="isRenderListas" :options="listas.grupos" name="grupos-regra" id="grupos-regra" v-model="model.gruposIds" :url="$urls.GRUPOS" />
        </el-form-item>
        <el-form-item class="position-relative toggle-cluster" :label="`Centro de Custos${model.clusterCentroDeCustosBool ? ' (Cluster)' : ''}:`">
          <div class="toogle-multiselect-cluster">
              <small class="label-toogle-cluster">{{ model.clusterCentroDeCustosBool ? 'Alterar para empresas' : 'Alterar para cluster' }}&nbsp;&nbsp;</small>
              <el-switch v-b-popover.hover.top="'Alternar combo clusters/empresas.'" v-model="model.clusterCentroDeCustosBool"></el-switch>
          </div>
          <div v-show="!model.clusterCentroDeCustosBool" v-loading="loadingListas">
              <select2-multiple v-if="isRenderListas" :options="listas.centrosDeCustos" name="regra-centro-custor" v-model="model.centroDecustosIds" :url="$urls.CENTROS_DE_CUSTO"></select2-multiple>
          </div>
          <div v-show="model.clusterCentroDeCustosBool" v-loading="loadingListas">
              <select2-multiple v-if="isRenderListas" :options="listas.cluster" name="regra-centro-custor-c" v-model="model.clustersCentroDecustosIds" :url="$urls.DRE_LISTA_CLUSTER"></select2-multiple>
          </div>
        </el-form-item>
        <el-form-item class="position-relative toggle-cluster" :label="`Empresas${model.clusterEmpresaBool ? ' (Cluster)' : ''}:`">
          <div class="toogle-multiselect-cluster">
              <small class="label-toogle-cluster">{{ model.clusterEmpresaBool ? 'Alterar para empresas' : 'Alterar para cluster' }}&nbsp;&nbsp;</small>
              <el-switch v-b-popover.hover.top="'Alternar combo clusters/empresas.'"
                          v-model="model.clusterEmpresaBool"></el-switch>
          </div>
          <div v-show="model.clusterEmpresaBool == false" v-loading="loadingListas">
              <select2-multiple v-if="isRerender" :options="listas.empresas" name="empresasASelect" v-model="model.empresasIds" :url="`${$urls.EMPRESAS}?marcas=${model.marcas.join(',')}`"></select2-multiple>
          </div>
          <div v-show="model.clusterEmpresaBool == true" v-loading="loadingListas">
              <select2-multiple v-if="isRenderListas" :options="listas.cluster" name="empresasACluster" v-model="model.clustersEmpresasIds" :url="$urls.DRE_LISTA_CLUSTER"></select2-multiple>
          </div>
        </el-form-item>
        
        <el-row :gutter="10"><!-- REGRAS DE ACESSO -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Admnistrador">
              <el-checkbox v-model="isAdmin">Todos os acessos liberados</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <!-- <el-form-item label="Visualizar">
              <el-checkbox v-model="isVisualizar">Visualizar todas as telas</el-checkbox>
            </el-form-item> -->
          </el-col>
        </el-row>
        <el-form-item v-show="!isAdmin" v-loading="loadingRegras" label="Regras" class="regras-container">
          <el-row :gutter="10" align="stretch">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-for="(item,i) in listas.regrasAcessoSistema" :key="i" v-show="(item.name !== 'sysAdmin')">
                <div class="regra-box">
                  <el-checkbox class="regra-box-header" :indeterminate="tempAcessos[i].isIndeterminate" v-model="tempAcessos[i].checkAll" @change="(...opt) => handleCheckAll(tempAcessos[i], item.action, ...opt)">{{ item.name }}</el-checkbox>
                  
                  <el-checkbox-group class="regra-box-s" v-model="tempAcessos[i].action" @change="(...opt) => handleGroupChange(tempAcessos[i], item.action, ...opt)">
                    <el-checkbox v-for="(action, i2) in item.action" :label="action" :key="'check-2-'+i2"></el-checkbox>
                  </el-checkbox-group>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <template #modal-footer="{ hide }">
        <div class="float-right">
        <el-button size="small" @click="hide()">Fechar</el-button>
        <el-button size="small" type="primary" @click="salvar">Salvar</el-button> 
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Select2Multiple from '@/components/shared/Select2Multiple';
import SelectMarcas from '@/components/shared/SelectMarcas'


const getMarcaDefault = () => {
  let listaMarcas = window.GlobalVmo ? window.GlobalVmo.getMarcas() : []
  return listaMarcas.length ? [listaMarcas[0].id] : []
};

const regraModel = (data) => {
    if(data) {
        return {
          _id: data._id,
          clusterEmpresaBool: data.clusterEmpresaBool || false,
          clusterCentroDeCustosBool: data.clusterCentroDeCustosBool || false,
          clustersEmpresasIds: data.clustersEmpresasIds || [],
          clustersCentroDecustosIds: data.clustersCentroDecustosIds || [],
          centroDecustosIds: data.centroDecustosIds || [],
          nome: data.nome || '',
          gruposIds: data.gruposIds || [],
          empresasIds: data.empresasIds || [],
          acessos: data.acessos || [],
          marcas: data.marcas && data.marcas.length ? data.marcas.map(String) : getMarcaDefault(),
        }
    }
    return {
        _id: '',
        clusterEmpresaBool: false,
        clusterCentroDeCustosBool:false,
        clustersEmpresasIds:[],
        clustersCentroDecustosIds:[],
        centroDecustosIds: [],
        nome: '',
        gruposIds: [],
        empresasIds: [],
        acessos: [],
        marcas: getMarcaDefault()
    }
}

export default {
  name: 'ModalRegras',
  components:{
    Select2Multiple,
    SelectMarcas
  },
  props: {
    id: {
      type: String,
      require: false
    }
  },
  data() {
    return {
      loadingListas: false,
      loadingForm: false,
      loadingRegras: false,
      model: regraModel(),
      isRerender: true,
      listas: {
        empresas: [],
        cluster: [],
        grupos:[],
        centrosDeCustos: [],
        regrasAcessoSistema: []
      },
      tempAcessos: [],
      isAdmin: false,
      isVisualizar: false,
      rules: {
				nome: [{ required: true, message: 'Nome é um campo obrigatório!', trigger: 'blur' }]
			}
    };
  },
  computed: {
    isRenderListas(){ return !this.loadingListas }
  },
  watch: {
    'model.marcas'() { // sempre que marcas for alterado, redesenha o select de empresas
      this.isRerender = false;
      this.$nextTick(()=>{ 
          this.listas.empresas = []
          this.isRerender = true;
      });
    }
  },
  methods: { 
    handleCheckAll(source, arr, value) {
      source.action = value ? arr : [];
      source.isIndeterminate = false;
    },
    handleGroupChange(source, arr, value) {
      const sourceLength = source.action.length

      if(sourceLength === arr.length) {
        source.isIndeterminate = false;
        source.checkAll = true;
      } else {
        source.isIndeterminate = sourceLength > 0 && sourceLength < arr.length;
        source.checkAll = false;
      }
    },
    openModal() {
        const _this = this

        _this.getListas();
        _this.getRegrasAcessoSistema();

        if(_this.id) {
            _this.getRegra();
            
            return
        }
        _this.model = regraModel();
        
    },
    fecharModal() {
        this.isAdmin = false;
        this.model = regraModel();
        this.$refs['formRegra'].clearValidate();
        this.$bvModal.hide('modal-regra-usuario')
    },
    salvar() {
      const ctx = this;
      ctx.$refs['formRegra'].validate((valid) => {
          if (!valid) {
            ctx.$notify.error({
              title: 'Validação',
              message: `Por favor, preencha todos os campos obrigatórios`,
              position:'top-left'
            });
            return;
          }
          if(!ctx.isAdmin) {
            ctx.model.acessos = ctx.tempAcessos.filter(acesso => acesso.action.length)
          } else {
            ctx.model.acessos = [{ Name: "sysAdmin", action: [] }]
          }
          
          // salvar
          ctx.saveRegra(this.model);// caso edit add como parametro
      });
    },
    // requests
    async saveRegra(formModel) {
      try {
        this.loadingForm = true;
        let response = this.model._id
        ?  await this.axios.put(this.$urls.EDITAR_UMA_REGRA, formModel)
        :  await this.axios.post(this.$urls.CRIAR_UMA_REGRA, this.model);

        if(response.status !== 200) {
            this.$notify.error({
                title: 'Obter detalhe',
                message: `Não foi possível criar regra de usuário`,
                position:'top-left'
            });
            return
        }

        this.fecharModal()
        this.$notify.success({
            title: 'Sucesso',
            message: `Regra de Usuário criada com sucesso`,
            position:'top-left'
        });
        this.$parent.listarRegraAcessos();

      } catch(err) {
          this.$notify.error({
              title: 'Erro interno',
              message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
              position:'top-left'
          });
      } finally {
          this.loadingForm = false
      }
    },
    async getRegrasAcessoSistema() {
      
      this.loadingRegras = true;

      try {
        const response = await this.axios.get(this.$urls.OBTER_REGRAS_DO_SISTEMA);

        if (response.status !== 200) {
          this.logErro();
          return;
        }

        this.listas.regrasAcessoSistema = JSON.parse(JSON.stringify(response.data));
        this.tempAcessos = JSON.parse(JSON.stringify(response.data));

        this.tempAcessos.forEach(item => {
          this.$set(item, 'checkAll', false);
          this.$set(item, 'isIndeterminate', false);
          item.action = [];
        });
      } catch (error) {
        console.error("Erro ao obter regras do sistema:", error);
        this.logErro();
      } finally {
        this.loadingRegras = false;
      }
    },
    async getRegra() {
      const _this = this;

      this.loadingForm = true;

      try {
        const response = await this.axios.get(`${this.$urls.OBTER_REGRA_POR_ID}/${this.id}`);

        if (response.status !== 200) {
          return;
        }

        this.model = regraModel(response.data);

        if (response.data && response.data.acessos) {
          this.isAdmin = response.data.acessos.length <= 1 && response.data.acessos.find(item => item.name === 'sysAdmin');

          if (!this.isAdmin) {
            this.tempAcessos.forEach((acesso) => {
              const findItem = _this.model.acessos.find(item => item.name === acesso.name);
              if (findItem) {
                acesso.action = findItem.action;
              }
            });
          }
        }
      } catch (error) {
        console.error("Erro ao obter regra:", error);
      } finally {
        this.loadingForm = false;
      }
    },
    async getListas() {
      this.loadingListas = true;

      try {
        const urlsEmpresas = [this.$urls.EMPRESAS, this.$urls.DRE_LISTA_CLUSTER, this.$urls.GRUPOS, this.$urls.CENTROS_DE_CUSTO];
        const requests = urlsEmpresas.map(url => this.axios.get(url));
        const responses = await Promise.all(requests);

        this.listas.empresas = responses[0].data;
        this.listas.cluster = responses[1].data;
        this.listas.grupos = responses[2].data;
        this.listas.centrosDeCustos = responses[3].data;
      } catch (error) {
        console.error("Erro ao obter listas:", error);
      } finally {
        this.loadingListas = false;
      }
    }
  }
};
</script>

<style lang="scss">
.input-treeview { display:block;}
.regras-container {
  width:100%;
}
.regra-box {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 15px 15px;
  height: 220px;
  margin-bottom: 10px;

  .regra-box-header { 
    width: 100%;
    background: #e7f4ff;
    position: relative;
    top: -2px;
    padding: 1px 15px 5px;
    border-radius: 5px;

    .el-checkbox__label{
      font-size: 14px; 
      color:#000;
    }
  }
  .regra-box-s { 
    margin:0
  }
}
</style>
